const loopTypes = {
    once: THREE.LoopOnce,
    repeat: THREE.LoopRepeat,
    pingpong: THREE.LoopPingPong,
};

function escapeRegExp(str) {
    return str.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
}

document.addEventListener("DOMContentLoaded", () => {
    AFRAME.registerComponent("animation-mixer", {
        schema: {
            clip: {
                default: "*",
            },
            duration: {
                default: 0,
            },
            crossFadeDuration: {
                default: 0.1,
            },
            loop: {
                default: "repeat",
                oneOf: Object.keys(loopTypes),
            },
            repetitions: {
                default: Infinity,
                min: 0,
            },
            removeHands: {
                default: false,
            },
        },
        init: function () {
            this.model = null;
            this.mixer = null;
            this.activeActions = [];
            this.data.first = true;
        },
        initMixer(animations, skeleton) {
            this.mixer = new THREE.AnimationMixer(this.el.object3D);
            this.mixer.uncacheRoot(this.mixer.getRoot());
            const filteredAnimations = animations.slice();

            for (let i = 0; i < animations.length; i++) {
                const tracks = Array.from(animations[i].tracks);
                const filteredTracks = [];

                for (let j = 0; j < tracks.length; j++) {
                    if (
                        !tracks[j].name.startsWith("Neck") &&
                        !tracks[j].name.startsWith("Head") &&
                        !tracks[j].name.startsWith("RightEye") &&
                        !tracks[j].name.startsWith("LeftEye") &&
                        !tracks[j].name.startsWith("RightForeArm")
                    ) {
                        filteredTracks.push(tracks[j]);
                    }
                }

                filteredAnimations[i].tracks = filteredTracks;
            }

            this.el.object3D.animations = animations;
            this.model = this.el.object3D;
        },
        remove: function () {
            if (this.mixer) {
                this.mixer.stopAllAction();
            }
        },
        update: function (previousData) {
            this.stopAction();
            if (this.data.clip) {
                this.playAction();
            }
        },
        stopAction: function () {
            for (let i = 0; i < this.activeActions.length; i++) {
                this.activeActions[i].fadeOut(0.5);
            }

            this.activeActions.length = 0;
        },
        playAction: function () {
            if (!this.mixer) {
                return;
            }

            const model = this.model;
            const data = this.data;
            const animations = model.animations;

            if (!animations.length) {
                return;
            }

            const clipRegExp = new RegExp(
                "^" + data.clip.split(/\*+/).map(escapeRegExp).join(".*") + "$"
            );

            for (let i = 0, animation; (animation = animations[i]); i++) {
                if (animation.name.match(clipRegExp)) {
                    const clipAction = this.mixer.clipAction(animation).reset();
                    clipAction.enabled = true;
                    clipAction.clampWhenFinished = true;

                    if (data.duration) {
                        clipAction.setDuration(data.duration);
                    }

                    clipAction
                        .setLoop(loopTypes[data.loop], data.repetitions)
                        .fadeIn(0.5)
                        .play();
                    this.activeActions.push(clipAction);
                }
            }
        },
        tick: function (time, timeDelta) {
            if (this.mixer && !isNaN(timeDelta)) {
                this.mixer.update(timeDelta / 1000);
            }
        },
    });
});
